import { AbstractEditEntityComponent } from '@abstracts/entities/edit-entity';
import { formatDate } from '@angular/common';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgbModal, NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { EnableFreeChargeDialogContentComponent } from '@components/dialog/enable-free-charge-dialog-content/enable-free-charge-dialog-content.component';
import { EnablePublicChargeDialogContentComponent } from '@components/dialog/enable-public-charge-dialog-content/enable-public-charge-dialog-content.component';
import { EnablePrivateChargeDialogContentComponent } from '@components/dialog/enable-private-charge-dialog-content/enable-private-charge-dialog-content.component';
import { DiagnosticChargingStationDialogContentComponent } from '@components/dialog/diagnostic-charging-station-dialog/diagnostic-charging-station-dialog-content/diagnostics-charging-station-dialog-content.component';
import { PatchChargingStation } from '@dto/httpPatch/patchChargingStation';
import { ChargingStation } from '@models/charging-station';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { UsersService } from '@services/entity/users.service';
import { OperatorsService } from '@services/entity/operators.service';
import { TransactionsService } from '@services/entity/transactions.service';
import { plainToClass } from 'class-transformer';
import { latLng, marker, tileLayer, Map, icon } from 'leaflet';
import { MapService } from '../../../../services/map/map.service';
import { RemoteStartStopDialogContentComponent } from '@components/dialog/remote-start-stop-dialog-content/remote-start-stop-dialog-content.component';
import { ToastService } from '@services/toast/toast.service';
import Swal from 'sweetalert2';
import { Model } from '../../../../models/model';
import { Profile } from '../../../../models/profile';
import { UpdateDetalisFromOcppResponse } from '@dto/updateDetalisFromOcppResponse';
import { QRCodeElementType } from 'angularx-qrcode';
import { CustomersService } from '../../../../services/entity/customers.service';
import { PatchChargingStationAllowedUsers } from '../../../../dto/httpPatch/patchChargingStationAllowedUsers';
import { CustomersTableEntry } from '../../../../dto/customersTableEntry';
import { ConnectorSystems } from '../../../../models/connectorSystems';
import { ChargingPower } from '../../../../models/chargingPower';
import { LOAD_WASM } from 'ngx-scanner-qrcode';

@Component({
  selector: 'app-details-charging-station',
  templateUrl: './details-charging-station.component.html',
  styleUrls: ['./details-charging-station.component.scss'],
})
export class DetailsChargingStationComponent extends AbstractEditEntityComponent implements OnInit {


  public className = 'DetailsChargingStationComponent';
  public entity: ChargingStation;
  public freeChargeStatus: boolean;
  public publicChargeStatus: boolean;
  public privateChargeStatus: boolean;

  public isOperator: boolean = false;
  public isCustomer: boolean = false;
  public isUser: boolean = false;
  public isSupporter: boolean = false;
  public qrCodeUrl: string = '';
  public elementType: QRCodeElementType = "img";
  public oldId: number;
  public switchCustomer: boolean = false;
  public currentChargeMode: any;
  private map: Map;
  private modes: string[] = [];
  public updateDetailsResponse: UpdateDetalisFromOcppResponse
  public operator: any;
  public operatorId: string;
  public connectorSystems: ConnectorSystems[] = [];
  public chargingPower: ChargingPower[] = [];

  customers: CustomersTableEntry[] = [];
  models: Model[] = [];
  model: Model[] = [];
  profile: Profile;
  options = {
    layers: [
      tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxNativeZoom: 19, maxZoom: 22, attribution: '© OpenStreetMap' })
    ],
    zoom: 15,
  };
  lat: string;
  lon: string;
  changeCustomer: boolean = false;
  oldCsId: number;

  @Input() set entityData(data: ChargingStation) {
    this.entity = data;
    console.log("this.entity", this.entity);
  }

  constructor(
    private chargingStationsService: ChargingStationsService,
    private transactionService: TransactionsService,
    private customersService: CustomersService,
    private usersService: UsersService,
    private operatorsService: OperatorsService,
    private mapService: MapService,
    private dialog: NgbModal,
    private toastService: ToastService,
    public injector: Injector
  ) {
    super(chargingStationsService, injector);
  }

  ngOnInit() {
    this.getRoles();
    this.authenticationService.getLoggedInUserSubject().subscribe(res => {
      this.operatorId = res.id;
    });
    super.ngOnInit();

  }

  afterInit() {
    this.disableInputs();
    this.chargingStationsService.statusUpdateEventEmitter.subscribe((event) => {
      this.disableInputs();
    });
    if (this.entity.address.latitude != '0' && this.entity.address.longitude != '0') {
      setTimeout(() => { this.loadMap(this.entity.address.latitude, this.entity.address.longitude); }, 200)
    } else {
      this.updateMap();
    }
    window.dispatchEvent(new Event('resize'));
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.isCustomer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.isOperator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.isUser = true;
    }
    this.isSupporter = this.authenticationService.userHasRole('Supporter')
  }

  getProfile() {
    this.chargingStationsService.getProfile(this.entity.model.profileId).subscribe(result => {
      this.profile = result;
    }, error => { });
  }

  disableInputs() {
    if (this.isUser) {
      this.formService.form?.disable();
    }

    if (this.isOperator) {
      this.formService.form.get('installationDate').enable();
      this.formService.form.get('connectorSystem').enable();
    }
    else {
      this.formService.form.get('installationDate').disable();
      this.formService.form.get('connectorSystem').disable();
    }
    this.formService.form.get('chargingstationGroups').disable();
    if (this.entity.chargingPoints[0].statusId != 1) {
      this.formService.form.get('csId').disable();
    }

    if (this.isOperator) {
      this.customersService.getCustomer(this.entity.customerId).subscribe(
        cc => {
          this.formService.form.get('customerName').setValue(cc.company);
        }, error => { })
    }
  }

  onMapReady(map: Map) {
    this.map = map;
    this.map.invalidateSize();
    window.dispatchEvent(new Event('resize'));
  }

  getMoreEntities() {
    if (this.isOperator) {
      this.usersService.getOperatorOfUser(this.operatorId).subscribe(result => {
        this.operator = result;
      }, error => { });
      this.operatorsService.getCustomersTableOfOperator(1).subscribe(result => {
        this.customers = result;
      }, error => {
        this.customers = null;
      })
      this.chargingStationsService.getConnectorSystems().subscribe(result => {
        this.connectorSystems = result;
        //console.log(this.connectorSystems)
      }, error => { });
      this.chargingStationsService.getChargingPower().subscribe(result => {
        this.chargingPower = result;
        //console.log(this.connectorSystems)
      }, error => { });
    };

    if (this.entity?.chargingPoints[0].statusId != 1 && this.entity.chargingPoints[0].statusId != 10 && this.entity.chargingPoints[0].statusId != 11) {
      if (!this.isUser) {
        this.chargingStationsService.UpdateDetailsFromOcpp(this.primaryKey.toString()).subscribe(result => {
          this.updateDetailsResponse = result;
          console.log(result)
        }, error => {
        })
      }
    }
  }

  async CalculateGPS() { // for calculate coordinates button
    var form = this.formService.form
    const location = `${form.get('street').value} ${form.get('houseNumber').value}, ${form.get('postalCode').value} ${form.get('city').value}`
    this.mapService.getMapPosition(location).subscribe(result => {
      this.lat = result.lat;
      this.lon = result.lon;
      this.loadMap(this.lat, this.lon)
    }, error => {
      console.warn(error)
      this.toastService.warn('Die eingegebene Adresse ist nicht validiert!');
    });
    this.formService.form.get('lat').setValue(this.lat)
    this.formService.form.get('lon').setValue(this.lon)
    this.formService.form.get('lat').markAsDirty()
    this.formService.form.get('lon').markAsDirty()
  }

  async updateMap() { //for initialization/after saving
    var form = this.formService.form
    const location = `${form.get('street').value} ${form.get('houseNumber').value}, ${form.get('postalCode').value} ${form.get('city').value}`
    this.mapService.getMapPosition(location).subscribe(result => {
      if (this.entity.address?.latitude != "0" && this.entity.address?.longitude != "0") {
        this.lat = this.entity.address?.latitude
        this.lon = this.entity.address?.longitude
        this.loadMap(this.lat, this.lon)
      } else {
        this.CalculateGPS();
        this.entity.address.latitude = result.lat;
        this.entity.address.longitude = result.lon;
        this.lat = result.lat;
        this.lon = result.lon;
        form.controls['lat'].setValue(result.lat);
        form.controls['lon'].setValue(result.lon);
        this.loadMap(this.lat, this.lon)
      }

    }, error => {
      console.warn(error)
      this.toastService.warn('Die eingegebene Adresse ist nicht validiert!');
    });
  }

  loadMap(lat: string, lon: string) {
    this.map.setView(latLng(parseFloat(lat), parseFloat(lon)));
    const newMarker = marker(
      [parseFloat(lat), parseFloat(lon)],
      {
        icon: icon({
          iconSize: [25, 41],
          iconAnchor: [13, 41],
          iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
          shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png'
        })
      }
    );
    this.map.addLayer(newMarker);
    this.map.invalidateSize();
    window.dispatchEvent(new Event('resize'));
  }

  initializeEntity(entity) {
    this.entity = plainToClass(ChargingStation, entity);
    this.getModus();
    this.qrCodeUrl = `${window.location.origin}/pc?cs=${this.entity.id}`
    this.oldId = this.entity.customerId;
    this.getMoreEntities();
  }

  getModus() {
    this.freeChargeStatus = this.entity.isFreeCharge;
    this.privateChargeStatus = this.entity.isPrivateCharge;
    this.publicChargeStatus = this.entity.isPublicCharge;
    this.modes = [];
    if (this.freeChargeStatus) {
      this.modes.push('free');
      this.currentChargeMode = 'free';
    }
    if (this.privateChargeStatus) {
      this.modes.push('authorize');
      this.currentChargeMode = 'authorize';
    }
    if (this.publicChargeStatus) {
      this.modes.push('public');
      this.currentChargeMode = 'public'
    }
  }


  createForm() {
    this.formService.validators = {
      name: [Validators.required],
      address: [Validators.required],
      manufacturer: [Validators.required],
      modelId: [],
      installationDate: [Validators.required],
      connectorSystem: [],
      chargingPower: [],
      cableLength: [],
      localIP: [],
      key: [],
    };

    // Angepasster evseIdValidator, der null und leere Werte zulässt
    const evseIdValidator = (control: UntypedFormControl) => {
      const value = control.value;
      if (value === null || value.trim() === "") {
        return null; // null und leere Werte sind gültig
      }
      const evseIdPattern = /^[Dd][Ee]\*?[Cc][Uu][Bb]\*?[Ee][A-Za-z0-9]{1,20}$/;
      return evseIdPattern.test(value) ? null : { invalidEvseId: true };
    };

    // Angepasster uniqueEvseIdValidator, der null und leere Werte ignoriert
    const uniqueEvseIdValidator: ValidatorFn = (formArray: AbstractControl) => {
      const evseIds = formArray.value
        .map((item: { evseId: string | null | undefined }) => item.evseId)
        .filter(evseId => evseId !== null && evseId !== undefined && evseId.trim() !== "");

      const duplicates = evseIds.filter((item, index) => evseIds.indexOf(item) !== index);

      // Markiere einzelne Felder
      const controls = (formArray as UntypedFormArray).controls;
      controls.forEach(control => {
        const evseId = control.get('evseId')?.value;
        if (duplicates.includes(evseId)) {
          control.get('evseId')?.setErrors({ duplicateEvseId: true });
        } else {
          const errors = control.get('evseId')?.errors;
          if (errors) {
            delete errors.duplicateEvseId;
            if (Object.keys(errors).length === 0) {
              control.get('evseId')?.setErrors(null);
            }
          }
        }
      });

      return duplicates.length > 0 ? { duplicateEvseId: true } : null;
    };


    // console.log("this.entity.chargingPoints", this.entity.chargingPoints);
    // EvseId: FormArray für dynamische chargingPoints erstellen
    const chargingPointsArray = new UntypedFormArray(
      this.entity.chargingPoints.map(point => new UntypedFormGroup({
        evseId: new UntypedFormControl(point.evseId, [evseIdValidator]),
        publicKey: new UntypedFormControl(point.publicKey)
      })), uniqueEvseIdValidator);

    // console.log("chargingPointsArray", chargingPointsArray);

    this.formService.form = new UntypedFormGroup({
      name: new UntypedFormControl(this.entity.name, this.formService.validators['name']),
      customer: new UntypedFormControl(this.entity.customerId),
      customerName: new UntypedFormControl(''),
      chargingstationGroups: new UntypedFormControl(this.entity.chargingstationGroupsDto),
      postalCode: new UntypedFormControl(this.entity.address?.postalCode, this.formService.validators['address']),
      city: new UntypedFormControl(this.entity.address?.city, this.formService.validators['address']),
      street: new UntypedFormControl(this.entity.address?.street, this.formService.validators['address']),
      houseNumber: new UntypedFormControl(this.entity.address?.houseNumber, this.formService.validators['address']),
      lat: new UntypedFormControl(this.entity.address?.latitude, this.formService.validators['address']),
      lon: new UntypedFormControl(this.entity.address?.longitude, this.formService.validators['address']),
      manufacturer: new UntypedFormControl(this.entity.manufacturer?.id, this.formService.validators['manufacturer']),
      modelId: new UntypedFormControl(this.entity.model?.id, this.formService.validators['modelId']),
      isErk: new UntypedFormControl(this.entity.model?.profile?.isErk),
      installationDate: new UntypedFormControl(
        formatDate(this.entity.installationDate, 'yyyy-MM-dd', 'de-DE'),
        this.formService.validators['installationDate']
      ),
      connectorSystem: new UntypedFormControl(this.entity.connectorSystems?.id, this.formService.validators['connectorSystem']),
      chargingPowerId: new UntypedFormControl(this.entity.chargingPower?.id, this.formService.validators['chargingPower']),
      chargingPower: new UntypedFormControl(this.entity.chargingPowerName, this.formService.validators['chargingPower']),
      cableLength: new UntypedFormControl(this.entity.cableLength, this.formService.validators['cableLength']),
      localIP: new UntypedFormControl(this.entity.localIP, this.formService.validators['localIP']),
      key: new UntypedFormControl(this.entity.key, this.formService.validators['key']),
      chargeMode: new UntypedFormControl(this.currentChargeMode),
      chargingProfile: new UntypedFormControl(''),
      chargingPoints: chargingPointsArray,  // FormArray für die dynamischen chargingPoints
      csId: new UntypedFormControl(this.entity.csId),
      ticket: new UntypedFormControl("Placeholder")
    });


    this.formService.formCreated = true;

    // Bedingungen zum Aktivieren/Deaktivieren von Feldern
    if (this.isUser) {
      this.formService.form?.disable();
    }

    if (this.isOperator) {
      this.formService.form.get('installationDate').enable();
      this.formService.form.get('connectorSystem').enable();
    }
    else {
      this.formService.form.get('installationDate').disable();
      this.formService.form.get('connectorSystem').disable();
    }
    this.formService.form.get('chargingstationGroups').disable();

    if (this.entity.chargingPoints[0].statusId != 1) {
      this.formService.form.get('csId').disable();
    }

    if (this.isOperator) {
      this.customersService.getCustomer(this.entity.customerId).subscribe(
        cc => {
          this.formService.form.get('customerName').setValue(cc.name);
        }, error => { });
    }

    if (this.isSupporter) {
      this.formService.form.disable();
    }
  }


  switchUser() {
    !this.switchCustomer ? this.switchCustomer = true : this.switchCustomer = false;
  }

  onSubmit(formValue) {
    if (this.formService.form.invalid) {
      this.toastService.error('Bitte füllen Sie alle Pflichtfelder aus.')
      this.formService.form.markAllAsTouched()
      return
    }
    const patchChargingStation: PatchChargingStation = {
      name: formValue.name,
      customerId: formValue.customer,
      postalCode: formValue.postalCode,
      city: formValue.city,
      street: formValue.street,
      houseNumber: formValue.houseNumber,
      lat: formValue.lat,
      lon: formValue.lon,
      manufacturerId: formValue.manufacturer,
      modelId: formValue.modelId,
      installationDate: formValue.installationDate,
      connectorSystemsId: formValue.connectorSystem,
      chargingPowerId: formValue.chargingPowerId,
      cableLength: formValue.cableLength,
      chargingPoints: formValue.chargingPoints.map((point, i) => ({
        // include all previous parameters to be able to map in the backend
        ...this.entity.chargingPoints[i],
        // overwrite evseId and publicKey with form values
        evseId: point.evseId,
        publicKey: point.publicKey
      })),
      csId: formValue.csId
    }
    if (this.changeCustomer) {
      patchChargingStation.installationDate = new Date();
    }
    this.oldCsId = this.entity.customerId;
    this.chargingStationsService.patchEntity(this.entity.id, patchChargingStation).subscribe(result => {
      this.toastService.success('Änderungen erfolgreich gespeichert.');
      this.entity = plainToClass(ChargingStation, result);
      this.entityLoadedEvent.emit(this.entity);
      this.updateMap();
      if (this.changeCustomer) {
        this.deauthorize();
        this.customersService.getCustomer(this.oldCsId).subscribe(
          ccustomer => {
            if (ccustomer.name == 'CUBOS-Pool') {
              this.transactionService.deleteTransactionsOfChargingStation(this.entity.id).subscribe(result => {
                this.toastService.success('Testladevorgänge wurden gelöscht.');
              }, error => {
              })
            }
          }, error => {
            console.error('no production account')
          })
      }
      this.formService.form.markAsPristine();
    }, error => {

      switch (error.Message) {
        case 'CsId could not be in Guid format!':
          this.toastService.error('CsId darf nicht in Guid Format sein!');
          break;
        case 'Same CsId already exists!':
          this.toastService.error('Die angegebene CsId existiert bereits in der Datenbank. Bitte geben Sie eine eindeutige CsId an.');
          break;
        // case 'unvalid address':
        //     this.toastService.error('Die eingegebene Adresse ist nicht validiert!');
        //     break;
        default:
          this.toastService.error('Die Änderungen konnten nicht gespeichert werden');
          if (error.message) {
            this.toastService.error(error.message);
          }
          break;
      }
    });
  }

  updateAddress() {
    var id = this.formService.form.get('customer').value;
    this.customersService.getMasterUserOfCustomer(id).subscribe(address => {
      if (address == null) {
        this.toastService.error("Fehler: Der ausgewählte Customer besitzt keinen MasterUser.")
        this.formService.form.get('customer').setValue(this.oldId);
        this.formService.form.get('street').setValue(this.entity.address.street);
        this.formService.form.get('postalCode').setValue(this.entity.address.postalCode);
        this.formService.form.get('city').setValue(this.entity.address.city);
        this.formService.form.get('houseNumber').setValue(this.entity.address.houseNumber);
        this.changeCustomer = false;
        return;
      }

      Swal.fire({
        title: $localize`:@@ChangeDialogSaveSuccessHeader:Besitzer wirklich wechseln?`,
        icon: 'question',
        text: 'Beim Besitzerwechsel werden alle Authorisierungen gelöscht. Fortfahren?',
        showDenyButton: true,
        confirmButtonText: $localize`:@@DialogOkButton:OK`,
        denyButtonText: 'Abbrechen',
        denyButtonColor: 'primary',
        confirmButtonColor: 'primary'
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Neue Adresse speichern?',
            text: 'Möchten Sie auch die Adresse des neuen Besitzers für diese Ladestation übernehmen?',
            showDenyButton: true,
            confirmButtonText: 'Ja',
            denyButtonText: 'Nein',
            denyButtonColor: 'primary',
            confirmButtonColor: 'primary'
          }).then((result) => {
            if (result.isConfirmed) {
              this.formService.form.get('street').setValue(address.street);
              this.formService.form.get('postalCode').setValue(address.postcode);
              this.formService.form.get('city').setValue(address.city);
              this.formService.form.get('houseNumber').setValue(address.houseNumber);
              this.updateMap();
              this.CalculateGPS();
              Swal.fire({
                title: 'Besitzer und Adresse wurden geändert und gespeichert.',
                text: '',
                icon: 'info'
              })
            } else if (result.isDenied) {
              Swal.fire({
                title: 'Besitzer wurde geändert und gespeichert.',
                text: '',
                icon: 'info'
              })
              this.formService.form.get('street').setValue(this.entity.address.street);
              this.formService.form.get('postalCode').setValue(this.entity.address.postalCode);
              this.formService.form.get('city').setValue(this.entity.address.city);
              this.formService.form.get('houseNumber').setValue(this.entity.address.houseNumber);
            }
            this.onSubmit(this.formService.form.value);
          })
          this.CalculateGPS();
          this.changeCustomer = true;
        } else if (result.isDenied) {
          Swal.fire('Besitzerwechsel wurde abgebrochen', '', 'info')
          this.formService.form.get('customer').setValue(this.oldId);
          this.formService.form.get('street').setValue(this.entity.address.street);
          this.formService.form.get('postalCode').setValue(this.entity.address.postalCode);
          this.formService.form.get('city').setValue(this.entity.address.city);
          this.formService.form.get('houseNumber').setValue(this.entity.address.houseNumber);
          this.changeCustomer = false;
        }
      });
    }, error => { });
  }

  deauthorize() {
    const patch: PatchChargingStationAllowedUsers = {
      userIds: []
    };
    this.chargingStationsService.patchEntityWithEndpoint(this.entity.getPrimaryKey(), 'allowedUsers', patch).subscribe(result => {
      this.synchronWhitelistNow();
    }, error => {
      this.toastService.error('Autorisierungen konnten nicht entfernt werden.')
    });
  }

  synchronWhitelistNow() {
    this.chargingStationsService.updateChargingStationWhitelist(this.entity.getPrimaryKey()).subscribe(result => {
      this.toastService.info('Autorisierungen wurden entfernt.');
    }, error => {
      this.toastService.error('Autorisierung fehlgeschlagen.')
    });
  }

  openPrivateChargeDialog(mode: string) {
    const dialogRef = this.dialog.open(EnablePrivateChargeDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.chargingStation = this.entity;
    dialogRef.componentInstance.mode = mode;
    dialogRef.componentInstance.currentStatus = this.privateChargeStatus;

    dialogRef.result.then((result) => {
    }, (backdrop) => {
    });
  }

  openPublicChargeDialog(mode: string) {
    const dialogRef = this.dialog.open(EnablePublicChargeDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.chargingStation = this.entity;
    dialogRef.componentInstance.mode = mode;
    dialogRef.componentInstance.currentStatus = this.publicChargeStatus;

    dialogRef.result.then((result) => {
    }, (backdrop) => {
    });
  }

  openChangeFreeChargeDialog() {
    const dialogRef = this.dialog.open(EnableFreeChargeDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.chargingStation = this.entity;
    dialogRef.componentInstance.currentStatus = this.freeChargeStatus;

    dialogRef.result.then((result) => {
      if (result.state == 'failure') {
        this.getModus();
      }
      dialogRef.close();
    });
  }

  openRemoteStartStopDialog(start: boolean, connector?: number) {
    const dialogRef = this.dialog.open(RemoteStartStopDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.start = start;
    dialogRef.componentInstance.chargingPointConnectorId = connector;
    dialogRef.componentInstance.chargingStation = this.entity;

    dialogRef.result.then((result) => {
      dialogRef.close();
    });
  }

  openDiagnosticsDialog(): void {
    const dialogRef = this.dialog.open(DiagnosticChargingStationDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.entity = this.entity;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }

  copysuccess() {
    this.toastService.success('Wert wurde in die Zwischenablage kopiert.');
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@ChangeDialogSaveSuccessHeader:Einstellungen wurden gespeichert!`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    }).then((result) => {
      this.createForm();
    });
  }

  getModel(manufacturerId) {
    this.model = this.models.filter(x => x.manufacturerId == manufacturerId);
  }


  openLocalIPLink() {
    var localIP = 'http://' + this.entity.localIP;
    window.open(localIP, '_blank');
  }

  openMapLink() {
    var mapLink = 'https://www.google.de/maps/place/' + this.entity.location;
    window.open(mapLink, '_blank');
  }

  openLatLonLink() {
    var latLink = 'https://www.google.com/maps/search/?api=1&query=' + this.entity.address?.latitude + ',' + this.entity.address?.longitude;
    window.open(latLink, '_blank');
  }

  downloadQrCode(parent: any) {
    let parentElement = null

    if (this.elementType === "canvas") {
      // fetches base 64 data from canvas
      parentElement = parent.qrcElement.nativeElement
        .querySelector("canvas")
        .toDataURL("image/png")
    } else if (this.elementType === "img" || this.elementType === "url") {
      // fetches base 64 data from image
      // parentElement contains the base64 encoded image src
      // you might use to store somewhere
      parentElement = parent.qrcElement.nativeElement.querySelector("img").src
    } else {
      alert("Set elementType to 'canvas', 'img' or 'url'.")
    }

    if (parentElement) {
      // converts base 64 encoded image to blobData
      let blobData = this.convertBase64ToBlob(parentElement)
      // saves as image
      const blob = new Blob([blobData], { type: "image/png" })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      // name of the file
      link.download = "QR-Code"
      link.click()
    }
  }

  private convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(";base64,")
    // hold the content type
    const imageType = parts[0].split(":")[1]
    // decode base64 string
    const decodedData = window.atob(parts[1])
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length)
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i)
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType })
  }

  changeMode(mode: string) {
    if (mode != null && mode != this.currentChargeMode) {
      switch (mode) {
        case 'free':
          this.openChangeFreeChargeDialog();
          break;
        case 'authorize':
          this.openPrivateChargeDialog('');
          break;
        case 'public':
          this.openPublicChargeDialog('');
      }
    }
  }

  public selectedChargingPointIndex: number = null;
  setSelectedChargingPointIndex(index: number) {
    this.selectedChargingPointIndex = index;
  }

  setEvseId(evseId: string): void {
    if (evseId.indexOf('DECUB') < 0) {
      const error = `${evseId} ist keine gültige EVSE ID von CUBOS.`;
      console.error(error)
      this.toastService.error(error);
      return;
    }
    const chargingPointsArray = this.formService.form.get('chargingPoints') as UntypedFormArray;

    if (
      this.selectedChargingPointIndex !== null &&
      this.selectedChargingPointIndex !== undefined &&
      this.selectedChargingPointIndex >= 0 &&
      this.selectedChargingPointIndex < chargingPointsArray.length
    ) {
      const chargingPointGroup = chargingPointsArray.at(this.selectedChargingPointIndex) as UntypedFormGroup;

      if (chargingPointGroup) {
        chargingPointGroup.get('evseId')?.setValue(evseId);
        let point = '';
        if (chargingPointsArray.length > 1) point = `${this.selectedChargingPointIndex + 1}. `;
        point += 'Ladepunkt';
        this.toastService.success(`${evseId} ist als EVSE ID für den ${point} eingetragen.`);
      } else {
        console.error('Charging point group not found at index:', this.selectedChargingPointIndex);
      }
    } else {
      console.error('Invalid index for selectedChargingPointIndex:', this.selectedChargingPointIndex);
    }
  }
}
